function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    "data-testid": "iconSvg",
    focusable: "false",
    height: "30px",
    viewBox: "0 0 24 24",
    width: "30px",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      display: "inline-block",
      verticalAlign: "middle"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-testid": "iconPath",
    fillRule: "evenodd",
    d: "M2.258 10.756l18.264-7.432a.156.156 0 01.164.258L9.267 14.105a.16.16 0 01-.166.032L2.266 11.52a.41.41 0 01-.008-.763zm7.26 4.311c0-.043.019-.085.05-.114l12.069-11.12a.156.156 0 01.257.149L18.68 18.62a.412.412 0 01-.234.288.42.42 0 01-.374-.015l-5.041-2.73-2.743 4.633a.419.419 0 01-.778-.207l.008-5.522z",
    style: {
      fill: "currentcolor"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.e12da2dc10ed8a8c00d46468a6dc094b.svg";
export { ForwardRef as ReactComponent };